import { Button, Modal, ModalActions, ModalContent } from '@uplift/ui-v2';
import React from 'react';
import { ROUTING_CONFIG, paymentsTabRoute } from '@uplift/constants';
import { Link, useRouteMatch } from 'react-router-dom';
import { mobileBreakpoint, useIsMobile, useL10n } from '@uplift/hooks';
import { makeStyles } from 'tss-react/mui';
import { useCurrentuser } from '@uplift/contexts';


export const RestrictedAccessModal: React.VFC = () => {
  const me = useCurrentuser();
  const l10n = useL10n();
  const { classes } = useStyles();
  const isMobile = useIsMobile(mobileBreakpoint);
  const routeMatch = useRouteMatch();

  const [ _open, setOpen ] = React.useState<boolean | null>(null);
  const open = React.useMemo(() => {
    // list of pages where the modal should not be shown
    if ([
      ROUTING_CONFIG.payments,
      ROUTING_CONFIG.paymentsTab,
      ROUTING_CONFIG.insurance,
      ROUTING_CONFIG.support,
    ].includes(routeMatch.path)) {
      return false;
    }
    if (_open === null && me?.rules?.nonpayment) {
      return true;
    }

    return _open;
  }, [ _open, me?.rules?.nonpayment, routeMatch.path ]);

  return (
    <Modal
      title={l10n.accountSettings.billing.restrictedAccess}
      open={open}
      maxWidth="md"
      slotProps={{ paper: { style: { width: '600px' } } }}
      showCloseIcon={false}
    >
      <ModalContent>{l10n.accountSettings.billing.restrictedAccessMessage}</ModalContent>
      <ModalActions disableSpacing={isMobile} className={isMobile ? classes.actionsMobile : classes.actions}>
        <Button
          variant="outlined"
          color="secondary"
          component={Link}
          className={classes.button}
          onClick={() => setOpen(false)}
          to={ROUTING_CONFIG.insurance}
        >
          {l10n.accountSettings.billing.viewInsurance}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          className={classes.button}
          onClick={() => setOpen(false)}
          component={Link}
          to={paymentsTabRoute.createLink({ tab: 'overview' })}
        >
          {l10n.accountSettings.billing.payBalance}
        </Button>
      </ModalActions>
    </Modal>
  );
};


const useStyles = makeStyles({ name: 'restricted-access' })((theme) => ({
  actions: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
  },
  actionsMobile: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  button: {
    flex: 1,
    whiteSpace: 'nowrap'
  },
}));
